// API Configuration
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_ENDPOINTS = {
  BASE: `${API_BASE_URL}/api`,
  COURSES: `${API_BASE_URL}/api/courses`,
  CHAT: `${API_BASE_URL}/api/chat`,
  CHAT_COMMIT: `${API_BASE_URL}/api/chat/commit`,
  CHAT_STEP_COMPLETE: `${API_BASE_URL}/api/chat/step-complete`,
  CHAT_SESSION_STATS: `${API_BASE_URL}/api/chat/session-stats`,
  MOODLE_EXPORT: (courseId) => `${API_BASE_URL}/api/courses/${courseId}/export/moodle`,
  ECLASS_EXPORT: (courseId) => `${API_BASE_URL}/api/courses/${courseId}/export/eclass`,
};

// Local Storage Keys
export const STORAGE_KEYS = {
  COURSE_ID: 'currentCourseId', // Start-From-Scratch flow
  IMPORT_COURSE_ID: 'importCourseId', // Import flow course ID
  IMPORT_SESSION_ID: 'importSessionId', // Import flow session ID
};

// Step Configuration
export const STEPS = {
  METADATA: 1,
  GOALS: 2,
  ACTIVITIES: 3,
  FINISH: 4,
};

// Checkpoint Labels
export const CHECKPOINT_LABELS = {
  A: 'Checkpoint A',
  B: 'Checkpoint B',
  C: 'Checkpoint C',
  TRANSFORM: 'Transform',
};

